// extracted by mini-css-extract-plugin
export var GridRootElement = "internal-page-module--GridRootElement--d1617";
export var actionElement = "internal-page-module--actionElement--3ebbf";
export var actionElementSVG = "internal-page-module--actionElementSVG--46afc";
export var author = "internal-page-module--author--199e4";
export var authorStyle = "internal-page-module--authorStyle--e7db4";
export var backButton = "internal-page-module--backButton--cc434";
export var carrouselSize = "internal-page-module--carrouselSize--69877";
export var compsFlex = "internal-page-module--compsFlex--baebc";
export var cover = "internal-page-module--cover--a1fc5";
export var coverHeight = "internal-page-module--coverHeight--aade8";
export var coverImageInternalPage = "internal-page-module--coverImageInternalPage--38d3e";
export var darkButton = "internal-page-module--darkButton--7ed9f";
export var desktopContent = "internal-page-module--desktopContent--f9d4b";
export var desktopRelatedContent = "internal-page-module--desktopRelatedContent--b101a";
export var desktopTitle = "internal-page-module--desktopTitle--cd2ed";
export var h4Label = "internal-page-module--h4Label--18520";
export var hiddenTitle = "internal-page-module--hiddenTitle--4f811";
export var iconRelatedContent = "internal-page-module--iconRelatedContent--9da19";
export var innerInternalPage = "internal-page-module--innerInternalPage--e3b98";
export var labelButton = "internal-page-module--labelButton--d0ba6";
export var marginBetweenBlocs = "internal-page-module--marginBetweenBlocs--aff1b";
export var marginBetweenBlocsCkeditor = "internal-page-module--marginBetweenBlocsCkeditor--d15f3";
export var marginBetweenBlocsRelatedContent = "internal-page-module--marginBetweenBlocsRelatedContent--74270";
export var marginBetweenHeaderContent = "internal-page-module--marginBetweenHeaderContent--7124d";
export var marketingButtonWidth = "internal-page-module--marketingButtonWidth--25e6d";
export var noUpperCase = "internal-page-module--noUpperCase--114eb";
export var openRelatedContent = "internal-page-module--openRelatedContent--7b525";
export var pageInternAuthor = "internal-page-module--pageInternAuthor--30c3a";
export var redButton = "internal-page-module--redButton--4fffb";
export var relatedContent = "internal-page-module--relatedContent--e5783";
export var relatedContentContainer = "internal-page-module--relatedContentContainer--e9ca1";
export var relatedTitleBig = "internal-page-module--relatedTitleBig--50121";
export var rootContainer = "internal-page-module--rootContainer--a61fb";
export var rootDiv = "internal-page-module--rootDiv--332a2";
export var rootItem = "internal-page-module--rootItem--b7f4d";
export var rootItemInternalPage = "internal-page-module--rootItemInternalPage--5340d";
export var rootItemNoRelatedContents = "internal-page-module--rootItemNoRelatedContents--13e66";
export var rootItemRelatedContents = "internal-page-module--rootItemRelatedContents--e41ef";
export var rootSmartphoneInternalPage = "internal-page-module--rootSmartphoneInternalPage--86298";
export var rootWithoutRelated = "internal-page-module--rootWithoutRelated--31ac9";
export var smartphoneContent = "internal-page-module--smartphoneContent--09789";
export var smartphoneTitle = "internal-page-module--smartphoneTitle--c8afe";
export var titleBig = "internal-page-module--titleBig--66662";